import React from 'react';
import Form from "react-bootstrap/Form";

const CertificationInfoForm = ({fields, handleFieldChange, memType,
                                cert1Checks, handleCert1ChecksChange,
                                cert1ChecksMessage,
                                messages, page, isEdit}) => {
  return (
    <>
      <h3>資格</h3>
      <dl>
        <dt>医籍登録番号<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="medicalRegistrationNumber" size="lg">
            <Form.Control
              type="text"
              name="medicalRegistrationNumber"
              value={fields.medicalRegistrationNumber}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="medicalRegistrationNumberMessage" className="errorMessages">{messages.medicalRegistrationNumber.n}</p>
        </dd>

        <dt>取得年月日<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="certifiedDate" size="lg">
            <Form.Control
              type="text"
              mtp={memType}
              name="certifiedDate"
              value={fields.certifiedDate}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>例：2021/01/01</p>
          <p id="certifiedDateMessage" className="errorMessages">{messages.certifiedDate.n}</p>
       </dd>

        <dt>取得スポーツ医資格<span className="red">*</span></dt>
        <dd>
          <Form.Group size="lg">
            <Form.Check
              custom
              id="cert1Checks0"
              name="cert1Checks0"
              label="日本スポーツ協会公認スポーツドクター"
              type="checkbox"
              value="1"
              checked={ 1 == cert1Checks[0] }
              onChange={handleCert1ChecksChange}
            />
            <Form.Check
              custom
              label="日本整形外科学会認定スポーツ医"
              id="cert1Checks1"
              name="cert1Checks1"
              type="checkbox"
              value="2"
              checked={ 2 == cert1Checks[1] }
              onChange={handleCert1ChecksChange}
            />
            <Form.Check
              custom
              label="日本医師会健康スポーツ医"
              id="cert1Checks2"
              name="cert1Checks2"
              type="checkbox"
              value="3"
              checked={ 3 == cert1Checks[2] }
              onChange={handleCert1ChecksChange}
            />
            <Form.Check
              custom
              label="日本障がい者スポーツ協会障がい者スポーツ医"
              id="cert1Checks3"
              name="cert1Checks3"
              type="checkbox"
              value="4"
              checked={ 4 == cert1Checks[3] }
              onChange={handleCert1ChecksChange}
            />
            <Form.Check
              custom
              label="日本スポーツ協会公認スポーツデンティスト"
              id="cert1Checks4"
              name="cert1Checks4"
              type="checkbox"
              value="5"
              checked={ 5 == cert1Checks[4] }
              onChange={handleCert1ChecksChange}
            />
            <Form.Check
              custom
              label="なし"
              id="cert1Checks5"
              name="cert1Checks5"
              type="checkbox"
              value="6"
              checked={ 6 == cert1Checks[5] }
              onChange={handleCert1ChecksChange}
            />
          </Form.Group>
          <p id="cert1ChecksMessage" className="errorMessages">{ cert1ChecksMessage }</p>
        </dd>
      </dl>
    </>

  );
}

export default CertificationInfoForm;
